export default __webpack_public_path__ + "static/media/2_0152.d1b47380.webp";